module.exports = "<div class=theMap ng-controller=mapCtl> <div style=position:relative> <div id=map style=height:745px;width:100%></div> <angucomplete-alt id=ex1 placeholder=\"חפש עיר\" pause=100 selected-object=selectedMarker local-data=markers search-fields=field_google_map_name title-field=field_google_map_name description-field=title minlength=1 input-class=\"form-control form-control-small\"/> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./public/views/map.html
// module id = 143
// module chunks = 0